"use strict";
(function (global) {
  /**
  * Собрать реквизиты на сервере с помощью асинхронного вызова.
  *
  * @function WebAccess.services.requisite.build
  * @param {object} model Модель для построения реквизитов
  * @return {Deferred} Специальный deferred-объект.
  * @since 5.0.0.7100
  */
  global.build = function (model) {
    return WA.SRV.call("/Requisite.asmx/Build", { "Model": model });
  };

  /**
  * Собрать реквизиты на сервере с помощью синхронного вызова.
  *
  * @function WebAccess.services.requisite.buildSync
  * @param {object} model Модель для построения реквизитов
  * @return {Deferred} Специальный deferred-объект.
  * @since 5.0.0.7100
  */
  global.buildSync = function (model) {
    return WA.SRV.callSync("/Requisite.asmx/Build", { "Model": model });
  };

})(window.WebAccess.services.requisite);
